//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalePanelTimer from './timer.vue';
import TimerButton from './timerButton.vue';
import FloatingBasket from '../floatingBasket';
import { mapGetters } from 'vuex';
import setTimerIntervalMixin from '../../../mixins/setTimerInterval.mixin';

export default {
  components: {
    SalePanelTimer,
    TimerButton,
    FloatingBasket,
  },
  mixins: [setTimerIntervalMixin],
  props: {
    autoscaled: {
      type: Boolean,
      default: false,
    },
    isBasketActive: {
      type: Boolean,
      default: false,
    },
    basketCounter: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      timer: {
        duration: null,
        interval: null,
      },
    };
  },
  computed: {
    ...mapGetters('sale', ['isSaleWithoutPrice']),
    timerDuration() {
      const timerDuration = this.timer.duration;
      if (!timerDuration || !timerDuration.days) return ``;
      if (timerDuration._milliseconds <= 0) {
        return `${this.$tc('day', 0)} 00:00:00`;
      }
      return `${
        timerDuration.months()
          ? this.$tc('month', timerDuration.months(), timerDuration.months())
          : ''
      } ${this.$tc('day', timerDuration.days(), {
        days: timerDuration.days(),
      })} ${String(timerDuration.hours()).padStart(2, '0')}:${String(
        timerDuration.minutes(),
      ).padStart(2, '0')}:${String(timerDuration.seconds()).padStart(2, '0')}`;
    },
  },
  methods: {
    changeHelpDialogState() {
      this.$store.commit('sale/setChoiceDialog', true);
    },
  },
};
